import React from 'react'
import './Footer.scss';
import Coreai from '../../../Assets/Images/logo1.png';
export default function Footer() {
    return (
        <div>
            <footer>
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-grid-items">
                            <div className="footer-title">
                                <div className="footer-logo">
                                    <img src={Coreai} alt="Coreai"/>
                                </div>
                                <div className="footer-child-text">
                                    <p>
                                    We help you to develop Natural Language Processing, Computer Vision, Python based solutions. We create AI solutions with a natural language processing and a Computer Vision based interface. Come to CoreAI, the world is our playground!
                                    </p>
                                </div>
                                <div className="social-media">
                                    {/* <div className="round-icon-design">
                                        <i className="fab fa-facebook-f"></i>
                                    </div> */}
                                    <a href="https://www.linkedin.com/company/coreai-artificial-intelligence/?viewAsMember=true" target="_blank">
                                    <div className="round-icon-design">
                                        <i className="fab fa-linkedin-in"></i>
                                    </div>                                    
                                    </a>
                                </div>
                            </div>    
                        </div>    
                        <div className="footer-grid-items">
                            <div className="">
                                <div className="">
                                    <h3>Company</h3>
                                    <ul>
                                    <a href="#home-section">
                                        <li>Home</li>
                                    </a>
                                    <a href="#Business">
                                        <li>Business</li>
                                    </a>
                                    <a href="#mainpageservice">
                                        <li>Services</li>
                                    </a>
                                    <a href="#Technology">
                                        <li>Technology</li>
                                    </a>
                                   
                                    <a href="#AboutUs">
                                        <li>About Us</li>
                                    </a>
                                    <a href="#contact-page-align">
                                        <li>Contact</li>
                                    </a>
                                </ul>
                            </div>   
                            </div>    
                        </div>    
                        <div className="footer-grid-items">
                            <div className="">
                                <h3>Services</h3>
                                <ul>
                                    <a href="#mainpageservice">
                                        <li>Face Recognation</li>
                                    </a>
                                    <a href="#mainpageservice">
                                        <li>Natural Language Processing</li>
                                    </a>
                                    <a href="#mainpageservice">
                                        <li>Machine Learning</li>
                                    </a>
                                    <a href="#mainpageservice">
                                        <li>Deep Learning</li>
                                    </a>
                                    <a href="#mainpageservice">
                                        <li>Chat Bot</li>
                                    </a>
                                    <a href="#mainpageservice">
                                        <li>Sentiment Analysis</li>
                                    </a>
                                </ul>
                            </div>
                        </div>
                    </div> 
                    <div className="copy-right-text">
                        <p>
                        (C) 2021, CoreAI Artificial Intelligence
                        </p>
                    </div>   
                </div>
            </footer> 
        </div>  
    )
}
